/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Notifications from 'react-notify-toast';
import routes from '../views';

import Header from '../views/pages/Header';
import BottomTabs from '../views/pages/BottomTabs';
import {getls} from '../utils';
import nav from '../_nav';

class SiteLayout extends Component {
  componentDidMount() {

  }

  render() {
    return (

      <div data-aos="flip" >

        <Notifications />
		
		<Header 
			routes={routes} 
			nav={nav}
		/>
      
		
          <div className="page-content-wrapper pt-20 ">

            <Switch>
              {routes.map((page) => (
                <Route exact path={page.path} component={page.component} key={page} />
              ))}
            </Switch>

          </div>

		
		<BottomTabs />
		
		<iframe name="print_frame" id="print_frame" width="0" height="0" frameBorder="0" src="about:blank"></iframe>

      </div>

    );
  }
}
export default SiteLayout;
